import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
    beginHistoryTransaction,
    commitHistoryTransaction,
} from "../app/slices/HistorySlice";
import { deleteKeys } from "../app/slices/TrainingLocalizationSlice";
import { deleteInteraction } from "../app/slices/TrainingSlice";
import Interaction from "../models/interactions/Interaction";
import { getKeysFromInteraction } from "../helpers/KeysHelper";
import { removeWarningsAndErrorsForInteraction } from "../app/slices/ValidationSlice";

export const useDeleteInteraction = () => {
    const dispatch = useDispatch();
    const deleteInteractionHook = (interaction: Interaction) => {
        // do a switch here
        dispatch(deleteInteraction(interaction));

        var keysToDelete: string[] = getKeysFromInteraction(interaction, "key_");
        console.log(keysToDelete);

        dispatch(deleteKeys(keysToDelete));

        // delete all warnigns / errors related to this interaction
        dispatch(removeWarningsAndErrorsForInteraction({ interactionId: interaction.id }));
    };

    // Deletes a whole group as one undo step; localization keys are
    // deduplicated across the group before deletion.
    const deleteInteractionsHook = (interactions: Interaction[]) => {
        if (interactions.length === 0) return;
        if (interactions.length === 1) {
            deleteInteractionHook(interactions[0]);
            return;
        }

        const transaction = { id: `delete-interactions-${uuidv4()}` };
        dispatch(beginHistoryTransaction(transaction));
        const keysToDelete = new Set<string>();
        for (const interaction of interactions) {
            dispatch(deleteInteraction(interaction));
            getKeysFromInteraction(interaction, "key_").forEach((key) =>
                keysToDelete.add(key)
            );
            dispatch(
                removeWarningsAndErrorsForInteraction({
                    interactionId: interaction.id,
                })
            );
        }
        dispatch(deleteKeys([...keysToDelete]));
        dispatch(commitHistoryTransaction(transaction));
    };

    const getKeys = (obj: any): string[] => {
        var result: string[] = [];

        // if its an array -> go over every elem
        if (obj instanceof Array) {
            obj.map((elem) => {
                getKeys(elem).map((s) => result.push(s));
            });
        } else {
            for (var prop in obj) {
                if (typeof obj[prop] === "string") {
                    var str: string = obj[prop];
                    if (str.startsWith("key_")) result.push(obj[prop]);
                }
                if (obj[prop] instanceof Object || obj[prop] instanceof Array) {
                    getKeys(obj[prop]).map((s) => result.push(s));
                }
            }
        }
        return result;
    };

    return [deleteInteractionHook, deleteInteractionsHook] as const;
};
